import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageLayout from "../components/PageLayout";
import styles from "./pages.module.css";

import Bio from "../components/Bio";
import photoFilinski from "../assets/BioFilinski.jpg";
import photoKluwak from "../assets/BioKluwak.jpg";
import photoLubieniecki from "../assets/BioLubieniecki.jpg";

const photoMap = {
    "Maciej Filiński": photoFilinski,
    "Konrad Kluwak": photoKluwak,
    "Barbara Pabjan": null,
    "Ryszard Lubieniecki": photoLubieniecki,
};

export default function About() {
    const { i18n, t } = useTranslation();
    const [bioList, setBioList] = useState([]);

    useEffect(() => {
        fetch(`/data/bio/${i18n.language}.json`)
            .then((res) => {
                if (!res.ok) throw new Error("File not found");
                return res.json();
            })
            .then((data) => setBioList(data))
            .catch(() => {
                fetch(`/data/bio/en.json`)
                    .then((res) => res.json())
                    .then((data) => setBioList(data));
            });
    }, [i18n.language]);
    return (
        <PageLayout>
            <section className={styles.invitationSection}>
                <h2 className={styles.title}>{t("home.aboutTitle")}</h2>
                <p className={styles.text}>{t("home.aboutFullText")}</p>
            </section>
            <section className={styles.section}>
                <h2 className={styles.title}>{t("home.aboutTeamMembers")}</h2>
                {bioList.map((bio) => (
                    <Bio
                        key={bio.email}
                        name={bio.name}
                        position={bio.position}
                        email={bio.email}
                        description={bio.description}
                        photo={photoMap[bio.name]}
                    />
                ))}
            </section>

        </PageLayout>
    );
}